const user = (state) => {
  return state.user
}

const haveInitialData = (state) => {
  return state.user != null;
}

export default {
  user,
  haveInitialData,
}